/**
 * SharePoint Configuration Constants
 * Shared constants for SharePoint URLs and configuration
 * Can be used in both main and renderer processes
 */

import { FY_YEAR as FY_YEAR_DYNAMIC } from '../utils/sharepoint-env';

// These will be loaded from database via sharepoint-env (which reads from localStorage/file)
// For renderer process, these should be passed via IPC
export const SHAREPOINT_SITE_HOSTNAME = import.meta.env.VITE_SITE_HOSTNAME;
export const SHAREPOINT_SITE_PATH = import.meta.env.VITE_SITE_PATH;
export const SHAREPOINT_DOC_LIBRARY = import.meta.env.VITE_DOC_LIBRARY;
// Load FY_YEAR from database (via sharepoint-env which reads from localStorage/file dynamically)
// Using the same ConfigValue pattern as FY_YEAR so it reads from database each time it's accessed
export const SHAREPOINT_FY_YEAR = FY_YEAR_DYNAMIC;
export const USER_NAME = import.meta.env.VITE_USER_NAME;

// Construct base URLs
export const SHAREPOINT_BASE_URL = `https://${SHAREPOINT_SITE_HOSTNAME}${SHAREPOINT_SITE_PATH}`;
export const SHAREPOINT_DOC_LIBRARY_URL = `${SHAREPOINT_BASE_URL}/${SHAREPOINT_DOC_LIBRARY}`;

